<template>
  <div class="main-index">
    <div class="opportunity-head">
      <img class="opportunity-img" src="~@/assets/activity/opportunity-head.png" />
      <div class="opportunity-introduce">
        <p>你有线索，我有奖励</p>
        <p>在日常和客户的接触过程中</p>
        <p>你发现</p>
        <p>客户对某个恒生产品或者解决方案表现出了浓厚的兴趣</p>
        <p>或恒生产品或者解决方案可以满足客户某方面的需求</p>
        <p>快来U+平台进行线索登记</p>
        <p>U豆奖励、实物礼品等你来拿</p>
      </div>
      <div class="opportunity-scope">
        <div class="opportunity-scope-bg left">
          <!-- <img class="opportunity-img"  src="~@/assets/activity/opportunity-bg.png" /> -->
          <div class="title">适用范围</div>
          <div class="description">恒生全部产品/解决方案</div>
        </div>
        <div class="opportunity-scope-bg right">
          <div class="title">面向对象</div>
          <div class="description">恒生电子员工（除客户经理岗位）</div>
        </div>
      </div>
      <div class="opportunity-rules">
        <div class="opportunity-rules-bg ">
          <div class="title">参与规则</div>
          <div class="description">
            <p class="p-1">根据线索的有效性以及线索评分进行分级奖励</p>
            <p class="p-2">注：提交后可在 “协同 — 流程—我的请求”查看线索处理进度以及评分</p>
            <div class="flex">
              <div class="left">
                <p class="p-3">一重礼</p>
                <p class="p-4">线索有效（5分），奖励<span class="num">10000U豆</span>；</p>
                <p>线索有效且生成商机卡片（10分），奖励<span class="num">20000U豆</span></p>
              </div>
              <div class="split-line"></div>
              <div class="right">
                <p class="p-3">二重礼</p>
                <p class="p-4">累计<span class="num">15分</span>以上的小伙伴可获得额外神秘礼品，</p>
                <p>积分越高奖励越高</span></p>
              </div>
            </div>
            <p class="p-5">注：若线索重复，根据提交时间先后进行奖励</p>
          </div>
        </div>
      </div>
      <div class="opportunity-connect">
        <p>活动咨询联系：0571-26691719</p>
        <p>客服总部在线服务运营部 运营与市场管理总部</p>
      </div>
      <div class="opportunity-operate">
        <img class="opportunity-img" @click="jumpTo" src="~@/assets/activity/opportunity-btn.png" />
      </div>

    </div>

  </div>
</template>
<script>
export default {
  name: "OpportunityCollectActivity",
  methods: {
    jumpTo() {
      location.href = "/openplat-front/productList";
    },
  },
};
</script>

<style lang="scss" scoped>
.main-index {
  width: 100%;
  position: relative;
  background-color: #5a51ff;
  .opportunity-head {
    width: 800px;
    margin: 0 auto;
    display: block;
    position: relative;
  }
  .opportunity-img {
    width: 1016px;
    margin-left: -108px;
    height: 573px;
  }
  .opportunity-introduce {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(173, 225, 255, 1);
    box-shadow: 0px 5px 10px 0px rgba(45, 37, 225, 1);
    border-radius: 10px;
    width: 800px;
    height: 219px;
    position: absolute;
    top: 368px;
    // left:108px;
    padding: 22px;
    p {
      font-family: AlibabaPuHuiTi-Medium;
      font-size: 14px;
      color: #ffffff;
      text-align: center;
      line-height: 25px;
      text-shadow: 1px 1px 1px #2d25e1;
      font-weight: 500;
      margin-bottom: 0;
    }
  }
  .opportunity-scope {
    margin-top: 21px;
    display: flex;
    justify-content: space-between;
    .opportunity-scope-bg {
      width: 436px;
      height: 158px;
      background: url(~@/assets/activity/opportunity-bg.png) 0 0 no-repeat;
      background-size: cover;
      position: relative;
    }
    .left {
      margin-left: -23px;
    }
    .right {
      margin-left: -12px;
    }
    .title {
      font-family: AlibabaPuHuiTi-Medium;
      font-size: 16px;
      color: #ffeb9a;
      letter-spacing: 1px;
      text-align: center;
      line-height: 16px;
      font-weight: 500;
      color: #ffeb9a;
      position: absolute;
      left: 50px;
      top: 30px;
    }
    .description {
      font-family: AlibabaPuHuiTi-Medium;
      font-size: 14px;
      color: #ffffff;
      text-align: center;
      line-height: 25px;
      font-weight: 500;
      margin-top: 81px;
    }
  }
  .opportunity-rules {
    margin-left: -23px;
    margin-top: -18px;
    .opportunity-rules-bg {
      width: 846px;
      height: 284px;
      background: url(~@/assets/activity/opportunity-bg2.png) 0 0 no-repeat;
      background-size: cover;
      position: relative;
    }
    .title {
      font-family: AlibabaPuHuiTi-Medium;
      font-size: 16px;
      color: #ffeb9a;
      letter-spacing: 1px;
      text-align: center;
      line-height: 16px;
      font-weight: 500;
      position: absolute;
      left: 50px;
      top: 30px;
    }
    .description {
      color: #fff;
      font-family: AlibabaPuHuiTi-Regular;
      font-size: 14px;
      padding: 74px 58px 0;
      line-height: 22px;
      p {
        margin-bottom: 0;
      }
      .p-1 {
        color: #fff6d4;
        line-height: 25px;
      }
      .p-2 {
        opacity: 0.8;
        font-family: AlibabaPuHuiTi-Regular;
        font-size: 12px;
        line-height: 20px;
        margin-top: 8px;
      }
      .flex {
        display: flex;
        align-items: center;
      }
      .p-3 {
        background: #9797ff;
        border: 1px solid rgba(67, 71, 255, 1);
        border-radius: 100px;
        font-family: AlibabaPuHuiTi-Regular;
        font-size: 13px;
        display: inline-block;
        width: 68px;
        height: 21px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 12px;
      }
      .p-4 {
        margin-top: 9px;
      }
      .num {
        font-family: AlibabaPuHuiTi-Regular;
        color: #a7fffd;
      }
      .p-5 {
        font-family: AlibabaPuHuiTi-Regular;
        font-size: 12px;
        line-height: 20px;
        font-weight: 400;
        margin-top: 12px;
        margin-right: 36px;
      }
      .split-line {
        width: 1px;
        height: 55px;
        border-left: 1px solid rgba(173, 225, 255, 1);
      }
      .left,
      .right {
        width: 50%;
      }
      .right {
        padding-left: 35px;
      }
    }
  }
  .opportunity-connect {
    p {
      font-family: AlibabaPuHuiTi-Regular;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.8);
      text-align: center;
      line-height: 25px;
      font-weight: 400;
      margin-bottom: 0;
    }
  }
  .opportunity-operate {
    margin-top: 12px;
    padding-bottom: 84px;
    text-align: center;
    bottom: -60px;
    position: sticky;
    .opportunity-img {
      width: 363px;
      height: 72px;
      margin: auto;
      cursor: pointer;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/gtn/views/activities/opportunityCollect/opportunityCollectActivity.vue